import {
  mdiBookOpenPageVariant,
  mdiCashMultiple,
  mdiEmailNewsletter,
  mdiFileDocumentOutline,
  mdiShareVariant,
} from '@mdi/js';
import type { FrameworkStatus } from '../types';

export function getFrameworkName(frameworks: FrameworkStatus[], selectedItem: string | null): string {
  if (!selectedItem || !frameworks.length) return '';

  const frameworkId = selectedItem.split(':')[0];
  const framework = frameworks.find(f => f.frameworkId === frameworkId);
  return framework?.name || '';
}

export function getBreadcrumbTitle(
  frameworks: FrameworkStatus[],
  selectedItem: string | null,
  selectedTitle: string | null
): string {
  if (!selectedTitle) return '';

  const frameworkName = getFrameworkName(frameworks, selectedItem);
  const title = humanizeFileName(selectedTitle);

  if (frameworkName) {
    return `${frameworkName} / ${title}`;
  }

  return title;
}

export function getFileIcon(name: string) {
  if (!name) return mdiFileDocumentOutline;

  if (name === 'manuscript') {
    return mdiBookOpenPageVariant;
  }

  if (name === 'costs') {
    return mdiCashMultiple;
  }

  if (name.toLowerCase().includes('letter') || name.toLowerCase().includes('summary')) {
    return mdiEmailNewsletter;
  }

  if (name.toLowerCase().includes('highlights')) {
    return mdiShareVariant;
  }

  return mdiFileDocumentOutline;
}

export function humanizeFileName(name: string): string {
  if (!name) return '';

  // Handle special documents
  if (name === 'manuscript') {
    return 'Original Manuscript';
  }

  if (name === 'costs') {
    return 'Processing Costs';
  }

  // Define known framework prefixes (longest first to match correctly)
  const frameworkPrefixes = ['short_story_', 'query_letter_', 'novel_', 'roast_', 'non_fiction_', 'memoir_'];

  let humanName = name;

  // Remove framework prefix
  for (const prefix of frameworkPrefixes) {
    if (humanName.startsWith(prefix)) {
      humanName = humanName.substring(prefix.length);
      break;
    }
  }

  // Fallback: if no specific prefix matched, remove everything up to first underscore
  if (humanName === name && humanName.includes('_')) {
    humanName = humanName.replace(/^[^_]+_/, '');
  }

  // Remove file extension
  humanName = humanName.replace(/\.(md|txt)$/i, '');

  // Replace underscores and hyphens with spaces
  humanName = humanName.replace(/[_-]/g, ' ');

  // Capitalize each word
  humanName = humanName.replace(/\b\w/g, letter => letter.toUpperCase());

  return humanName;
}
